import { Card, CardContent } from "@/components/ui/card";
import { AddressManagement } from "./address-management";

export default function AddressScreen() {
  return (
    <div className="container mx-auto p-4 sm:p-6">
      <div className="space-y-6">
        <div>
          <h2 className="text-lg font-semibold mb-4">Tips & Tricks</h2>
          <Card className="w-full lg:w-80 bg-gray-50 border-0 mb-6">
            <CardContent className="pt-6">
              "Double click" an address to mark it as primary
            </CardContent>
          </Card>

          <h2 className="text-lg font-semibold mb-4">Addresses</h2>
          <AddressManagement />
        </div>
      </div>
    </div>
  );
}
